import json from './sprite.js';

export default {
    handle: 'es_SPT13-Game',
    label: 'es_SPT13-Game',
    json,
};
